// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-modal {
    background: rgba(0, 0, 0, .3);
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    text-align: left;
}

.message-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    max-width: 350px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    font-size: 17px;
    padding: 25px;
    z-index: 10000;
    box-shadow: 1px 1px 4px 1px #656565;
    background-color: #fff;
    border-radius: 5px;
}

.message-modal-2 {
    padding-bottom: 25px;
}

.message-modal-btn {
    width: 100%;
    border: 1px solid #b1b1b1;
    background-color: #d5d5d5;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 4px;
}

.message-modal-btn:hover {
    background-color: #a3a2a2;
}


.customer-info {
    margin-top: 30%;
    background-color: #e8e2e2;
    border-radius: 7px;
    padding: 7px 0 7px 10px;
}

.customer-info>div {
    display: flex;
}

.cust-text {
    color: #73777b;
    font-weight: 600;
}

.cust-phone svg {
    color: #066163;
    width: 1rem;
    margin-left: 5px;
}

.cust-phone>span {
    margin-top: 2.5px;
    margin-left: 12px;
    font-weight: 500;
}

.cust-work>span {
    color: #f66b0e;
    font-weight: 600;
    margin-right: 6px;
}

.cust-work {
    color: #0078aa;
    font-weight: 500;
    margin-right: 6px;
}

.cust-rest>span {
    color: #f66b0e;
    font-weight: 600;
    margin-right: 6px;
}

.cust-rest {
    color: #bd574e;
    font-weight: 500;
    margin-right: 6px;
}

.header {
    /* position: fixed;
    top: 0;
    left: 0;
    z-index: 100; */
}

.section1 {
    display: flex;
    position: relative;
}

.sidebar {
    width: 100%;
}

.section2 {
    position: absolute;
    top: 0;
    left: 12rem;
    width: calc(100% - 12rem);
}

.section2.main {
    left: 0;
    width: 100%;
}


.show_modal .modal-dialog {
    max-height: 98vh;
    overflow: auto;
}

.preview_wrap {
    overflow: auto;
    height: 83vh;
}

.customer-info {
    margin-top: 30%;
    background-color: #e8e2e2;
    border-radius: 7px;
    padding: 7px 0 7px 10px;
}

.excel-disable {
    display: flex;
    gap: 10px;
    /* width: 200px; */
    justify-content: flex-end;
}


@media(max-width:1279px) {
    .section2 {
        left: 105px;
        width: calc(100% - 105px);
    }

    .customer-info {
        padding: 7px 0 7px 1.25rem;
    }

    .tabulator_sorting_wrap {
        flex-direction: column-reverse;
        height: auto;
        gap: 10px;
    }

    .input-disable {
        display: none !important;
    }
}

.em {
    width: 30% !important;
}

@media(max-width:767px) {
    .section2 {
        left: 50% !important;
        transform: translateX(-50%);
        width: 100dvw;
        min-width: 100dvw;
    }

    .excel-disable {
        display: none;
    }

    .em {
        width: 100% !important;
    }
}


.customer-info>div {
    display: flex;
}

.cust-text {
    color: #73777b;
    font-weight: 600;
}

.cust-phone svg {
    color: #066163;
    width: 1rem;
    margin-left: 5px;
}

.cust-phone>span {
    margin-top: 2.5px;
    margin-left: 12px;
    font-weight: 500;
}

.cust-work>span {
    color: #f66b0e;
    font-weight: 600;
    margin-right: 6px;
}

.cust-work {
    color: #0078aa;
    font-weight: 500;
    margin-right: 6px;
}

.cust-rest>span {
    color: #f66b0e;
    font-weight: 600;
    margin-right: 6px;
}

.cust-rest {
    color: #bd574e;
    font-weight: 500;
    margin-right: 6px;
}

.litepicker .container__months .month-item-header .button-next-month>svg,
.litepicker .container__months .month-item-header .button-next-month>img {
    fill: transparent !important;
}

.litepicker .container__months .month-item-header .button-previous-month>svg,
.litepicker .container__months .month-item-header .button-previous-month>img {
    fill: transparent !important;
}

.tabBtn {
    width: 50%;
    text-align: center;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.tabBtn.active {
    background-color: #434242;
    color: #F6FBF4;
}

.pointer {
    cursor: pointer;
    font-weight: 600;
}

.pointer:hover {
    text-decoration: underline;
}

.update {
    color: #003577;
}

.file_form {
    font-weight: 300;
    color: #8292a3;
    display: block;
    appearance: none;
    background-color: #fff;
    border-width: 1px;
    padding-top: 0.5rem;
    padding-right: 0.75rem;
    padding-bottom: 0.5rem;
    padding-left: 0.75rem;
}

.favorite {
    width: 100%;
    height: calc(100dvh - 9rem);
}

.favorite-box {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 140px;
    padding: 15px;
    position: relative;
    height: auto !important;
    min-height: auto !important;
    max-height: 100% !important;
    overflow: scroll auto;
    -webkit-overflow-scrolling: touch;
}

.favorite-left-box {
    width: 300px;
    height: auto;
}

.favorite-top {
    width: 100%;
    color: #333;
    border-bottom: 1px solid #e5e5e5;
    font-size: 18px;
    padding: 10px;
    text-align: center;
}

.favorite-circle {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 1px solid #ddd;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.favorite-center {
    display: flex;
    align-items: center;
    justify-content: center;
}

.favorite-circle svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.favorite-list {
    width: 100%;
    margin-top: 30px;
    border: 1px solid #ddd;
    border-bottom: none;
}

.favorite-item {
    width: 100%;
    height: 45px;
    padding: 10px 15px;
    border-bottom: 1px solid #ddd;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.favorite-item.active {
    background-color: #ffffc3;
}

.favorite-item:hover {
    background-color: #ffffc3;
}

.icon-start {
    width: 18px;
    height: 18px;
    color: #afafaf;
    fill: yellow;
}

.favorite-text {
    color: gray;
    font-size: 11px;
    padding: 5px 0;
}

.header-favorite {
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 20px;
    color: #fff;
}

.header-favorite-item {
    padding: 10px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    gap: 5px;
}


.paylist-title-none {
    display: flex;
}

.paylist-title-display {
    display: none;
    align-items: center;
    height: 36px;
}

@media (max-width: 1300px) {
    .header-favorite {
        display: none;
    }
}

@media (max-width: 767px) {
    .header-favorite {
        display: none;
    }
}


@media (max-width: 640px) {
    .paylist-title-none {
        display: none;
    }

    .paylist-title-display {
        display: flex;
    }
}

.footer {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 15px;
    background-color: #000;
    z-index: 100;
    max-width: 1920px;
}

.footer1 {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 100;
    max-width: 1920px;

    background: #fff;
    border-top: 1px solid #e5e7eb;
    /* light gray */
    color: #374151;
    /* gray-700 */
    font-size: 12px;
}

/* Layout container */
.footer__inner {
    margin: 0 auto;
    padding: 8px 12px;
    /* 세로 여백 */
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 8px 16px;
}

/* Left side */
.footer__left {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    min-width: 0;
    word-break: keep-all;
    /* 한국어 단어 뭉텅이 줄바꿈 방지 */
}

.footer__brand {
    font-weight: 600;
    white-space: nowrap;
}

/* Company meta chips */
.footer__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    font-style: normal;
    /* <address>의 기본 이탤릭 제거 */
    opacity: .9;
}

.footer__meta>span {
    white-space: nowrap;
}

.footer__meta>span+span {
    position: relative;
    padding-left: 15px;
}

.footer__meta>span+span::before {
    content: "│";
    position: absolute;
    left: 0;
    top: 0;
    opacity: .4;
}

/* Right side */
.footer__right {
    white-space: nowrap;
    color: #6b7280;
    /* gray-500 */
    text-align: right;
}

/* Mobile */
@media (max-width:640px) {
    .footer__inner {
        grid-template-columns: 1fr;
        text-align: center;
    }

    .footer__right {
        order: 2;
    }

    .footer__left {
        justify-content: center;
    }

    .footer__meta>span {
        white-space: normal;
    }

    /* 좁은 화면에서 줄바꿈 허용 */
    .footer__meta>span+span::before {
        content: "";
    }

    /* 구분자 제거 */
}

/* 다크 모드 대응(선택) */
@media (prefers-color-scheme: dark) {
    .footer {
        background: #0b0f14;
        border-top-color: #1f2937;
        color: #cbd5e1;
    }

    .footer__right {
        color: #94a3b8;
    }
}





.tabulator .tabulator-tableHolder {
    width: calc(100%) !important;
}

.tabulator .tabulator-tableHolder::-webkit-scrollbar {
    width: 0px !important;
}

.list-detail-box {
    width: calc(100% - 30%);

    border: 1px solid #e7eaf3;
    height: 1000px;
}

.div-flex-1 {
    display: flex;
}

.div-flex-1-1 {
    /* width: calc(100% - 812px); */
    width: calc(100% - 1010px);
    max-width: 600px;
}

.div-flex-1-2 {
    /* width: 860px; */
    height: 738px;
}

.div-flex-1-3 {
    min-width: 500px;
}

.div-flex-1-4 {
    width: 100%;
    /* max-width: 400px; */
    max-width: 480px;
}

.div-flex-2 {
    display: flex;
}

.div-flex-2-1 {
    max-width: 920px;
    width: calc(100% - 400px);
    height: 738px
}

.canceled-row {
    position: relative;
}

/* 행 전체를 가로지르는 선 */
.canceled-row::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    border-top: 1px solid #850000;
    /* 색상, 두께를 원하는 대로 조절 */
    transform: translateY(-50%);
    z-index: 1;
    opacity: 0.5;
    /* 필요 시 조절 */
}

.dashboard-graph {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px 0;
}

.intro-padding {
    padding: 1rem 1rem;
    margin-top: 0.5rem;
}

.custom-input::placeholder {
    font-size: 16px;
    color: #aaa;
}

@media (max-width: 1500px) {
    .div-flex-1 {
        flex-direction: column;
        align-items: center;
    }

    .div-flex-1-1 {
        width: 100%
    }

    .div-flex-1-2 {
        /* width: 100%; */
        /* max-width: 860px; */
    }
}

@media (max-width: 1200px) {
    .div-flex-2 {
        flex-direction: column;
        align-items: center;
    }

    .div-flex-2-1 {
        max-width: 100%;
        width: 100%;
        height: auto
    }

    .div-flex-1-1 {
        width: 100%
    }

    .div-flex-1-2 {
        flex-direction: column;
        height: auto;
    }

    .div-flex-1-3 {
        width: 100%;
        min-width: 100%;
    }
}

@media (max-width: 640px) {
    .intro-padding {
        padding: .5rem .5rem 0
    }
}

@media (max-width: 600px) {
    .dashboard-graph {
        flex-direction: column;
        align-items: stretch;
        gap: 5px;
    }
}

.no-padding {
    padding: 0px !important;
    padding-bottom: 10px !important;
}

.spinner-modal {
    /* position: fixed;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center; */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.table-sort {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.fill-color,
.sort-color {
    color: #003577;
    fill: #003577;
}`, "",{"version":3,"sources":["webpack://./src/Pages/css/main.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,eAAe;IACf,aAAa;IACb,cAAc;IACd,mCAAmC;IACnC,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;;;mBAGe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,WAAW;AACf;;;AAGA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,yBAAyB;AAC7B;;;AAGA;IACI;QACI,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,8BAA8B;QAC9B,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,oBAAoB;QACpB,2BAA2B;QAC3B,aAAa;QACb,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gCAAgC;IAChC,eAAe;IACf,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,QAAQ;AACZ;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;;AAGA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,iBAAiB;;IAEjB,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,cAAc;IACd,aAAa;IACb,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,cAAc;IACd,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;AACjB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,WAAW;AACf;;AAEA,eAAe;AACf;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,iBAAiB;AACrB;;AAEA,WAAW;AACX;IACI;QACI,0BAA0B;QAC1B,kBAAkB;IACtB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;IACvB;;IAEA,mBAAmB;IACnB;QACI,WAAW;IACf;;IAEA,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI;QACI,mBAAmB;QACnB,yBAAyB;QACzB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;AACJ;;;;;;AAMA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;;IAEvB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,WAAW;IACX,6BAA6B;IAC7B,sBAAsB;IACtB,2BAA2B;IAC3B,UAAU;IACV,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI;IACJ;;IAEA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,WAAW;QACX;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,QAAQ;IACZ;AACJ;;AAEA;IACI,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI;;;;;8BAK0B;IAC1B,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;IAEI,cAAc;IACd,aAAa;AACjB","sourcesContent":[".error-modal {\r\n    background: rgba(0, 0, 0, .3);\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    z-index: 9999;\r\n    display: flex;\r\n    text-align: left;\r\n}\r\n\r\n.message-modal {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: 100%;\r\n    max-width: 350px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    flex-direction: column;\r\n    font-size: 17px;\r\n    padding: 25px;\r\n    z-index: 10000;\r\n    box-shadow: 1px 1px 4px 1px #656565;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n}\r\n\r\n.message-modal-2 {\r\n    padding-bottom: 25px;\r\n}\r\n\r\n.message-modal-btn {\r\n    width: 100%;\r\n    border: 1px solid #b1b1b1;\r\n    background-color: #d5d5d5;\r\n    height: 35px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n}\r\n\r\n.message-modal-btn:hover {\r\n    background-color: #a3a2a2;\r\n}\r\n\r\n\r\n.customer-info {\r\n    margin-top: 30%;\r\n    background-color: #e8e2e2;\r\n    border-radius: 7px;\r\n    padding: 7px 0 7px 10px;\r\n}\r\n\r\n.customer-info>div {\r\n    display: flex;\r\n}\r\n\r\n.cust-text {\r\n    color: #73777b;\r\n    font-weight: 600;\r\n}\r\n\r\n.cust-phone svg {\r\n    color: #066163;\r\n    width: 1rem;\r\n    margin-left: 5px;\r\n}\r\n\r\n.cust-phone>span {\r\n    margin-top: 2.5px;\r\n    margin-left: 12px;\r\n    font-weight: 500;\r\n}\r\n\r\n.cust-work>span {\r\n    color: #f66b0e;\r\n    font-weight: 600;\r\n    margin-right: 6px;\r\n}\r\n\r\n.cust-work {\r\n    color: #0078aa;\r\n    font-weight: 500;\r\n    margin-right: 6px;\r\n}\r\n\r\n.cust-rest>span {\r\n    color: #f66b0e;\r\n    font-weight: 600;\r\n    margin-right: 6px;\r\n}\r\n\r\n.cust-rest {\r\n    color: #bd574e;\r\n    font-weight: 500;\r\n    margin-right: 6px;\r\n}\r\n\r\n.header {\r\n    /* position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 100; */\r\n}\r\n\r\n.section1 {\r\n    display: flex;\r\n    position: relative;\r\n}\r\n\r\n.sidebar {\r\n    width: 100%;\r\n}\r\n\r\n.section2 {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 12rem;\r\n    width: calc(100% - 12rem);\r\n}\r\n\r\n.section2.main {\r\n    left: 0;\r\n    width: 100%;\r\n}\r\n\r\n\r\n.show_modal .modal-dialog {\r\n    max-height: 98vh;\r\n    overflow: auto;\r\n}\r\n\r\n.preview_wrap {\r\n    overflow: auto;\r\n    height: 83vh;\r\n}\r\n\r\n.customer-info {\r\n    margin-top: 30%;\r\n    background-color: #e8e2e2;\r\n    border-radius: 7px;\r\n    padding: 7px 0 7px 10px;\r\n}\r\n\r\n.excel-disable {\r\n    display: flex;\r\n    gap: 10px;\r\n    /* width: 200px; */\r\n    justify-content: flex-end;\r\n}\r\n\r\n\r\n@media(max-width:1279px) {\r\n    .section2 {\r\n        left: 105px;\r\n        width: calc(100% - 105px);\r\n    }\r\n\r\n    .customer-info {\r\n        padding: 7px 0 7px 1.25rem;\r\n    }\r\n\r\n    .tabulator_sorting_wrap {\r\n        flex-direction: column-reverse;\r\n        height: auto;\r\n        gap: 10px;\r\n    }\r\n\r\n    .input-disable {\r\n        display: none !important;\r\n    }\r\n}\r\n\r\n.em {\r\n    width: 30% !important;\r\n}\r\n\r\n@media(max-width:767px) {\r\n    .section2 {\r\n        left: 50% !important;\r\n        transform: translateX(-50%);\r\n        width: 100dvw;\r\n        min-width: 100dvw;\r\n    }\r\n\r\n    .excel-disable {\r\n        display: none;\r\n    }\r\n\r\n    .em {\r\n        width: 100% !important;\r\n    }\r\n}\r\n\r\n\r\n.customer-info>div {\r\n    display: flex;\r\n}\r\n\r\n.cust-text {\r\n    color: #73777b;\r\n    font-weight: 600;\r\n}\r\n\r\n.cust-phone svg {\r\n    color: #066163;\r\n    width: 1rem;\r\n    margin-left: 5px;\r\n}\r\n\r\n.cust-phone>span {\r\n    margin-top: 2.5px;\r\n    margin-left: 12px;\r\n    font-weight: 500;\r\n}\r\n\r\n.cust-work>span {\r\n    color: #f66b0e;\r\n    font-weight: 600;\r\n    margin-right: 6px;\r\n}\r\n\r\n.cust-work {\r\n    color: #0078aa;\r\n    font-weight: 500;\r\n    margin-right: 6px;\r\n}\r\n\r\n.cust-rest>span {\r\n    color: #f66b0e;\r\n    font-weight: 600;\r\n    margin-right: 6px;\r\n}\r\n\r\n.cust-rest {\r\n    color: #bd574e;\r\n    font-weight: 500;\r\n    margin-right: 6px;\r\n}\r\n\r\n.litepicker .container__months .month-item-header .button-next-month>svg,\r\n.litepicker .container__months .month-item-header .button-next-month>img {\r\n    fill: transparent !important;\r\n}\r\n\r\n.litepicker .container__months .month-item-header .button-previous-month>svg,\r\n.litepicker .container__months .month-item-header .button-previous-month>img {\r\n    fill: transparent !important;\r\n}\r\n\r\n.tabBtn {\r\n    width: 50%;\r\n    text-align: center;\r\n    font-weight: 600;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.tabBtn.active {\r\n    background-color: #434242;\r\n    color: #F6FBF4;\r\n}\r\n\r\n.pointer {\r\n    cursor: pointer;\r\n    font-weight: 600;\r\n}\r\n\r\n.pointer:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n.update {\r\n    color: #003577;\r\n}\r\n\r\n.file_form {\r\n    font-weight: 300;\r\n    color: #8292a3;\r\n    display: block;\r\n    appearance: none;\r\n    background-color: #fff;\r\n    border-width: 1px;\r\n    padding-top: 0.5rem;\r\n    padding-right: 0.75rem;\r\n    padding-bottom: 0.5rem;\r\n    padding-left: 0.75rem;\r\n}\r\n\r\n.favorite {\r\n    width: 100%;\r\n    height: calc(100dvh - 9rem);\r\n}\r\n\r\n.favorite-box {\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: center;\r\n    gap: 140px;\r\n    padding: 15px;\r\n    position: relative;\r\n    height: auto !important;\r\n    min-height: auto !important;\r\n    max-height: 100% !important;\r\n    overflow: scroll auto;\r\n    -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.favorite-left-box {\r\n    width: 300px;\r\n    height: auto;\r\n}\r\n\r\n.favorite-top {\r\n    width: 100%;\r\n    color: #333;\r\n    border-bottom: 1px solid #e5e5e5;\r\n    font-size: 18px;\r\n    padding: 10px;\r\n    text-align: center;\r\n}\r\n\r\n.favorite-circle {\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 50%;\r\n    border: 1px solid #ddd;\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n.favorite-center {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.favorite-circle svg {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n.favorite-list {\r\n    width: 100%;\r\n    margin-top: 30px;\r\n    border: 1px solid #ddd;\r\n    border-bottom: none;\r\n}\r\n\r\n.favorite-item {\r\n    width: 100%;\r\n    height: 45px;\r\n    padding: 10px 15px;\r\n    border-bottom: 1px solid #ddd;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    cursor: pointer;\r\n}\r\n\r\n.favorite-item.active {\r\n    background-color: #ffffc3;\r\n}\r\n\r\n.favorite-item:hover {\r\n    background-color: #ffffc3;\r\n}\r\n\r\n.icon-start {\r\n    width: 18px;\r\n    height: 18px;\r\n    color: #afafaf;\r\n    fill: yellow;\r\n}\r\n\r\n.favorite-text {\r\n    color: gray;\r\n    font-size: 11px;\r\n    padding: 5px 0;\r\n}\r\n\r\n.header-favorite {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: end;\r\n    gap: 20px;\r\n    color: #fff;\r\n}\r\n\r\n.header-favorite-item {\r\n    padding: 10px 0px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    cursor: pointer;\r\n    gap: 5px;\r\n}\r\n\r\n\r\n.paylist-title-none {\r\n    display: flex;\r\n}\r\n\r\n.paylist-title-display {\r\n    display: none;\r\n    align-items: center;\r\n    height: 36px;\r\n}\r\n\r\n@media (max-width: 1300px) {\r\n    .header-favorite {\r\n        display: none;\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .header-favorite {\r\n        display: none;\r\n    }\r\n}\r\n\r\n\r\n@media (max-width: 640px) {\r\n    .paylist-title-none {\r\n        display: none;\r\n    }\r\n\r\n    .paylist-title-display {\r\n        display: flex;\r\n    }\r\n}\r\n\r\n.footer {\r\n    width: 100%;\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    height: 15px;\r\n    background-color: #000;\r\n    z-index: 100;\r\n    max-width: 1920px;\r\n}\r\n\r\n.footer1 {\r\n    width: 100%;\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    z-index: 100;\r\n    max-width: 1920px;\r\n\r\n    background: #fff;\r\n    border-top: 1px solid #e5e7eb;\r\n    /* light gray */\r\n    color: #374151;\r\n    /* gray-700 */\r\n    font-size: 12px;\r\n}\r\n\r\n/* Layout container */\r\n.footer__inner {\r\n    margin: 0 auto;\r\n    padding: 8px 12px;\r\n    /* 세로 여백 */\r\n    display: grid;\r\n    grid-template-columns: 1fr auto;\r\n    align-items: center;\r\n    gap: 8px 16px;\r\n}\r\n\r\n/* Left side */\r\n.footer__left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 16px;\r\n    flex-wrap: wrap;\r\n    min-width: 0;\r\n    word-break: keep-all;\r\n    /* 한국어 단어 뭉텅이 줄바꿈 방지 */\r\n}\r\n\r\n.footer__brand {\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n}\r\n\r\n/* Company meta chips */\r\n.footer__meta {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 5px;\r\n    font-style: normal;\r\n    /* <address>의 기본 이탤릭 제거 */\r\n    opacity: .9;\r\n}\r\n\r\n.footer__meta>span {\r\n    white-space: nowrap;\r\n}\r\n\r\n.footer__meta>span+span {\r\n    position: relative;\r\n    padding-left: 15px;\r\n}\r\n\r\n.footer__meta>span+span::before {\r\n    content: \"│\";\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    opacity: .4;\r\n}\r\n\r\n/* Right side */\r\n.footer__right {\r\n    white-space: nowrap;\r\n    color: #6b7280;\r\n    /* gray-500 */\r\n    text-align: right;\r\n}\r\n\r\n/* Mobile */\r\n@media (max-width:640px) {\r\n    .footer__inner {\r\n        grid-template-columns: 1fr;\r\n        text-align: center;\r\n    }\r\n\r\n    .footer__right {\r\n        order: 2;\r\n    }\r\n\r\n    .footer__left {\r\n        justify-content: center;\r\n    }\r\n\r\n    .footer__meta>span {\r\n        white-space: normal;\r\n    }\r\n\r\n    /* 좁은 화면에서 줄바꿈 허용 */\r\n    .footer__meta>span+span::before {\r\n        content: \"\";\r\n    }\r\n\r\n    /* 구분자 제거 */\r\n}\r\n\r\n/* 다크 모드 대응(선택) */\r\n@media (prefers-color-scheme: dark) {\r\n    .footer {\r\n        background: #0b0f14;\r\n        border-top-color: #1f2937;\r\n        color: #cbd5e1;\r\n    }\r\n\r\n    .footer__right {\r\n        color: #94a3b8;\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n.tabulator .tabulator-tableHolder {\r\n    width: calc(100%) !important;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder::-webkit-scrollbar {\r\n    width: 0px !important;\r\n}\r\n\r\n.list-detail-box {\r\n    width: calc(100% - 30%);\r\n\r\n    border: 1px solid #e7eaf3;\r\n    height: 1000px;\r\n}\r\n\r\n.div-flex-1 {\r\n    display: flex;\r\n}\r\n\r\n.div-flex-1-1 {\r\n    /* width: calc(100% - 812px); */\r\n    width: calc(100% - 1010px);\r\n    max-width: 600px;\r\n}\r\n\r\n.div-flex-1-2 {\r\n    /* width: 860px; */\r\n    height: 738px;\r\n}\r\n\r\n.div-flex-1-3 {\r\n    min-width: 500px;\r\n}\r\n\r\n.div-flex-1-4 {\r\n    width: 100%;\r\n    /* max-width: 400px; */\r\n    max-width: 480px;\r\n}\r\n\r\n.div-flex-2 {\r\n    display: flex;\r\n}\r\n\r\n.div-flex-2-1 {\r\n    max-width: 920px;\r\n    width: calc(100% - 400px);\r\n    height: 738px\r\n}\r\n\r\n.canceled-row {\r\n    position: relative;\r\n}\r\n\r\n/* 행 전체를 가로지르는 선 */\r\n.canceled-row::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 0;\r\n    width: 100%;\r\n    border-top: 1px solid #850000;\r\n    /* 색상, 두께를 원하는 대로 조절 */\r\n    transform: translateY(-50%);\r\n    z-index: 1;\r\n    opacity: 0.5;\r\n    /* 필요 시 조절 */\r\n}\r\n\r\n.dashboard-graph {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 10px 15px 0;\r\n}\r\n\r\n.intro-padding {\r\n    padding: 1rem 1rem;\r\n    margin-top: 0.5rem;\r\n}\r\n\r\n.custom-input::placeholder {\r\n    font-size: 16px;\r\n    color: #aaa;\r\n}\r\n\r\n@media (max-width: 1500px) {\r\n    .div-flex-1 {\r\n        flex-direction: column;\r\n        align-items: center;\r\n    }\r\n\r\n    .div-flex-1-1 {\r\n        width: 100%\r\n    }\r\n\r\n    .div-flex-1-2 {\r\n        /* width: 100%; */\r\n        /* max-width: 860px; */\r\n    }\r\n}\r\n\r\n@media (max-width: 1200px) {\r\n    .div-flex-2 {\r\n        flex-direction: column;\r\n        align-items: center;\r\n    }\r\n\r\n    .div-flex-2-1 {\r\n        max-width: 100%;\r\n        width: 100%;\r\n        height: auto\r\n    }\r\n\r\n    .div-flex-1-1 {\r\n        width: 100%\r\n    }\r\n\r\n    .div-flex-1-2 {\r\n        flex-direction: column;\r\n        height: auto;\r\n    }\r\n\r\n    .div-flex-1-3 {\r\n        width: 100%;\r\n        min-width: 100%;\r\n    }\r\n}\r\n\r\n@media (max-width: 640px) {\r\n    .intro-padding {\r\n        padding: .5rem .5rem 0\r\n    }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n    .dashboard-graph {\r\n        flex-direction: column;\r\n        align-items: stretch;\r\n        gap: 5px;\r\n    }\r\n}\r\n\r\n.no-padding {\r\n    padding: 0px !important;\r\n    padding-bottom: 10px !important;\r\n}\r\n\r\n.spinner-modal {\r\n    /* position: fixed;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center; */\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n}\r\n\r\n.table-sort {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.fill-color,\r\n.sort-color {\r\n    color: #003577;\r\n    fill: #003577;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
